import { TrendingListing } from 'models/Listing';
import { createContext } from 'react';

type TrendingListingsContextProps = {
  loading: boolean;
  trendings: Array<TrendingListing>;
};

export default createContext<Partial<TrendingListingsContextProps>>({
  loading: false,
  trendings: [],
});
